<template>
    <a-modal v-model="visible" width="900px" title="" :footer="null" centered @cancel="handleCancelEvent" class="modal-box">
        <a-form :form="form">
            <div v-for="(item, index) in typeList" :key="index">
                <a-form-item :label="item.title" v-if="item.label == type">
                    <a-upload
                        :show-upload-list="false"
                        :action="uploadImageUrl"
                        :data="{ type: 1 }"
                        :before-upload="info => beforeUpload(info)"
                        :headers="uploadHeaders"
                        @change="handleChange($event)"
                    >
                        <input type="hidden" v-decorator="[`${item.label}`, { rules: [{ required: true }] }]" />
                        <a-button icon="upload" type="primary">{{ $t('web.upload' /* 上传 */) }}</a-button>
                    </a-upload>
                    <div v-if="form.getFieldValue(item.label)">
                        <a :href="form.getFieldValue(item.label) | urlFilter(250)">{{ $t('web.download_file' /* 下载文件 */) }}</a>
                    </div>
                    <div slot="extra" class="error-color">
                        {{ $t('formConfig.please_upload_file_type', { type: fileTypeList.join('|') } /* 请上传{type}类型的文件 */) }}
                    </div>
                </a-form-item>
            </div>

            <a-button type="primary" @click="handleDownloadFileEvent" v-if="templateFile">{{ $t('web.download_template' /* 下载模板 */) }}</a-button>
            <div class="flex x-right">
                <a-button class="mr10" type="default" @click="handleCancelEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button type="primary" @click="handleSubmitEvent">{{ $t('web.submit' /* 提交 */) }}</a-button>
            </div>
        </a-form>
    </a-modal>
</template>

<script>
const fields = ['poster_ppt_cn', 'poster_ppt_en', 'full_text_cn', 'full_text_en', 'ppt_cn', 'ppt_en', 'abstract_annex', 'abstract_annex_en', 'video_url_cn'];
import userApi from '@/request/apiList';
import pick from 'lodash.pick';
export default {
    name: 'UploadFile',
    components: {},
    data() {
        return {
            fields,
            visible: false,
            loading: false,
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            type: '', // poster_ppt_cn poster_ppt_en 壁报 full_text_cn full_text_en 全文 ppt_cn ppt_en PPT abstract_annex abstract_annex_en 摘要全文 video_url_cn 视频
            info: {},
            fileTypeList: [],
            form: this.$form.createForm(this),
            typeList: [
                {
                    label: 'poster_ppt_cn',
                    title: this.$t('submission.upload.poster_ppt_cn' /* 中文壁报 */)
                },
                {
                    label: 'poster_ppt_en',
                    title: this.$t('submission.upload.poster_ppt_en' /* 英文壁报 */)
                },
                {
                    label: 'full_text_cn',
                    title: this.$t('submission.upload.full_text_cn' /* 中文全文附件 */)
                },
                {
                    label: 'full_text_en',
                    title: this.$t('submission.upload.full_text_en' /* 英文全文附件 */)
                },
                {
                    label: 'ppt_cn',
                    title: this.$t('submission.upload.ppt_cn' /* 中文PPT */)
                },
                {
                    label: 'ppt_en',
                    title: this.$t('submission.upload.ppt_en' /* 英文PPT */)
                },
                {
                    label: 'abstract_annex',
                    title: this.$t('submission.upload.abstract_cn' /* 中文摘要 */)
                },
                {
                    label: 'abstract_annex_en',
                    title: this.$t('submission.upload.abstract_en' /* 英文摘要 */)
                },
                {
                    label: 'video_url_cn',
                    title: this.$t('submission.upload.video_url_cn' /* 中文视频 */)
                },
                {
                    label: 'video_url_en',
                    title: this.$t('submission.upload.video_url_en' /* 英文视频 */)
                }
            ],
            templateFile: '' // 模板文件
        };
    },
    computed: {},
    methods: {
        show(info, type) {
            this.type = type;
            this.info = info;
            // 全文附件
            if (this.type == 'full_text_cn' || this.type == 'full_text_en') {
                this.fileTypeList = ['rar', 'zip', 'pdf', 'doc', 'docx'];
            } else if (this.type == 'ppt_cn' || this.type == 'ppt_en') {
                // ppt
                this.fileTypeList = ['ppt', 'pptx'];
            } else if (this.type == 'poster_ppt_cn' || this.type == 'poster_ppt_en') {
                // 壁报
                this.fileTypeList = ['ppt', 'pptx', 'docx', 'pdf', 'mp4', 'jpg', 'png', 'jpeg'];
            } else if (this.type == 'abstract_annex' || this.type == 'abstract_annex_en') {
                // 摘要
            }
            this.visible = true;
            this.$nextTick(() => {
                fields.forEach(v => {
                    this.form.getFieldDecorator(v);
                });
                this.form.setFieldsValue(pick(info.annex_list, fields));
            });
            this.getFormInfo();
        },
        handleCancelEvent() {
            this.visible = false;
        },
        handleSubmitEvent() {
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    let data = {
                        ...values,
                        abstract_id: this.info.id,
                        type: this.type
                    };
                    this.$request.post({ url: 'updateFile', data: data }).then(res => {
                        this.form.resetFields();
                        this.$message.success(this.$t('web.upload_success' /* 上传成功 */));
                        this.visible = false;
                    });
                }
            });
        },
        // 上传前
        beforeUpload(file) {
            let regFile = true;
            // 获取当前上传的文件后缀
            let suffix = file.name.split('.');
            suffix = suffix[suffix.length - 1];
            if (this.fileTypeList.indexOf(suffix) == -1) {
                regFile = false;
                this.$message.error(this.$t('formConfig.please_upload_file_type', { type: this.fileTypeList.join('|') } /* 请上传{type}类型的文件 */));
                return regFile;
            }
            return regFile;
        },
        // 上传修改
        handleChange(info) {
            if (info.file.status === 'uploading') {
                this.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    this.$message.success(this.$t('web.upload_success' /* 上传成功 */));
                    let obj = {};
                    obj[this.type] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            }
        },
        // 获取通道附件模板
        getFormInfo() {
            this.$request.post({ url: 'getFormInfo', data: { channel_id: this.info.channel_id, type: 25 } }).then(res => {
                const { data } = res;
                let list = data.filter(item => item.field_code == this.type);
                this.templateFile = list[0].ppt;
            });
        },
        // 下载模板
        handleDownloadFileEvent() {
            let a = document.createElement('a');
            a.href = 'https://files.sciconf.cn/' + this.templateFile;
            a.click();
        }
    },
    created() {},
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>
<style lang="less" scoped>
.preview-box {
    padding: 30px;
    background-color: #f9f9f9;
}
</style>
